// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorFallback_container__3rSRh","subContainer":"ErrorFallback_subContainer__3bgWX","alert":"ErrorFallback_alert__3QdbA"};